// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderSubscriber,
    ProviderSubscriberSortType,
    SupportCreateSubscriberPayload,
    SupportReplaceSubscriberPayload,
    SupportSubscriber,
    SupportSubscriberSortType,
    SupportUpdateSubscriberPayload,
    SupportCreateSubscriberPayloadToJSON,
    SupportReplaceSubscriberPayloadToJSON,
    SupportUpdateSubscriberPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderSubscriberFromJSON,
    SupportSubscriberFromJSON,
} from '../models';

export interface CreateSupportSubscriberRequest {
    supportCreateSubscriberPayload: SupportCreateSubscriberPayload;
}

export interface DisableSupportSubscriberRequest {
    id: string;
}

export interface GetProviderSubscriberRequest {
    id: string;
}

export interface GetSupportSubscriberRequest {
    id: string;
}

export interface ListProviderSubscribersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderSubscribersOrderEnum>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterDob?: Array<string>;
    filterCreated?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<ProviderSubscriberSortType>;
}

export interface ListSupportSubscribersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportSubscribersOrderEnum>;
    filterStarred?: string;
    filterActive?: string;
    filterTag?: Array<string>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterDob?: Array<string>;
    filterCreated?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<SupportSubscriberSortType>;
}

export interface ReplaceSupportSubscriberRequest {
    supportReplaceSubscriberPayload: SupportReplaceSubscriberPayload;
}

export interface UpdateSupportSubscriberRequest {
    id: string;
    supportUpdateSubscriberPayload: SupportUpdateSubscriberPayload;
}

/**
 * no description
 */
export class SubscriberApi extends runtime.BaseAPI {

    /**
     * Create a subscriber
     * Create a subscriber
     */
    async createSupportSubscriberRaw(requestParameters: CreateSupportSubscriberRequest): Promise<runtime.ApiResponse<SupportSubscriber>> {
        if (requestParameters['supportCreateSubscriberPayload'] === null || requestParameters['supportCreateSubscriberPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateSubscriberPayload','Required parameter requestParameters.supportCreateSubscriberPayload was null or undefined when calling createSupportSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:subscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriber`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateSubscriberPayloadToJSON(requestParameters['supportCreateSubscriberPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSubscriberFromJSON(jsonValue));
    }

    /**
     * Create a subscriber
     * Create a subscriber
     */
    async createSupportSubscriber(requestParameters: CreateSupportSubscriberRequest): Promise<SupportSubscriber> {
        const response = await this.createSupportSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a subscriber
     * Disable a subscriber
     */
    async disableSupportSubscriberRaw(requestParameters: DisableSupportSubscriberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:subscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriber/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a subscriber
     * Disable a subscriber
     */
    async disableSupportSubscriber(requestParameters: DisableSupportSubscriberRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a subscriber
     * Get a subscriber
     */
    async getProviderSubscriberRaw(requestParameters: GetProviderSubscriberRequest): Promise<runtime.ApiResponse<ProviderSubscriber>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriber"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/subscriber/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderSubscriberFromJSON(jsonValue));
    }

    /**
     * Gets a subscriber
     * Get a subscriber
     */
    async getProviderSubscriber(requestParameters: GetProviderSubscriberRequest): Promise<ProviderSubscriber> {
        const response = await this.getProviderSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a subscriber
     * Get a subscriber
     */
    async getSupportSubscriberRaw(requestParameters: GetSupportSubscriberRequest): Promise<runtime.ApiResponse<SupportSubscriber>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriber/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSubscriberFromJSON(jsonValue));
    }

    /**
     * Gets a subscriber
     * Get a subscriber
     */
    async getSupportSubscriber(requestParameters: GetSupportSubscriberRequest): Promise<SupportSubscriber> {
        const response = await this.getSupportSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of subscribers
     * Get a list of subscribers
     */
    async listProviderSubscribersRaw(requestParameters: ListProviderSubscribersRequest): Promise<runtime.ApiResponse<Array<ProviderSubscriber>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterDob) {
            queryParameters['filterDob'] = requestParameters.filterDob;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriber"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/subscriber`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderSubscriberFromJSON));
    }

    /**
     * Gets a list of subscribers
     * Get a list of subscribers
     */
    async listProviderSubscribers(requestParameters: ListProviderSubscribersRequest): Promise<Array<ProviderSubscriber>> {
        const response = await this.listProviderSubscribersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of subscribers
     * Get a list of subscribers
     */
    async listSupportSubscribersRaw(requestParameters: ListSupportSubscribersRequest): Promise<runtime.ApiResponse<Array<SupportSubscriber>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterDob) {
            queryParameters['filterDob'] = requestParameters.filterDob;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:subscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriber`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportSubscriberFromJSON));
    }

    /**
     * Gets a list of subscribers
     * Get a list of subscribers
     */
    async listSupportSubscribers(requestParameters: ListSupportSubscribersRequest): Promise<Array<SupportSubscriber>> {
        const response = await this.listSupportSubscribersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a subscriber
     * Replace a subscriber
     */
    async replaceSupportSubscriberRaw(requestParameters: ReplaceSupportSubscriberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceSubscriberPayload'] === null || requestParameters['supportReplaceSubscriberPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceSubscriberPayload','Required parameter requestParameters.supportReplaceSubscriberPayload was null or undefined when calling replaceSupportSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:subscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriber/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceSubscriberPayloadToJSON(requestParameters['supportReplaceSubscriberPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a subscriber
     * Replace a subscriber
     */
    async replaceSupportSubscriber(requestParameters: ReplaceSupportSubscriberRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportSubscriberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a subscriber
     * Update a subscriber
     */
    async updateSupportSubscriberRaw(requestParameters: UpdateSupportSubscriberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportSubscriber.');
        }

        if (requestParameters['supportUpdateSubscriberPayload'] === null || requestParameters['supportUpdateSubscriberPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateSubscriberPayload','Required parameter requestParameters.supportUpdateSubscriberPayload was null or undefined when calling updateSupportSubscriber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:subscriber", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/subscriber/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateSubscriberPayloadToJSON(requestParameters['supportUpdateSubscriberPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a subscriber
     * Update a subscriber
     */
    async updateSupportSubscriber(requestParameters: UpdateSupportSubscriberRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportSubscriberRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderSubscribersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportSubscribersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
